<template>
  <div class="state-management mb-4">
    <StateManagementDashboard />
  </div>
</template>

<script>
import StateManagementDashboard from "@/components/Widgets/StateManagement/StateManagementDashboard.vue";

export default {
  name: "GestionEstados",
  components: {
    StateManagementDashboard,
  },
};
</script>

<style scoped lang="scss"></style>
